import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
var router = new Router({
	routes: [
		{
			path: '/',
			redirect: {
				name: 'lose'
			}
		},
		{ // 首页
			path: '/index',
			name: 'index',
			title: '认证信息确认',
			component: () => import('@/components/Index')
		},
		{ // share
			path: '/share',
			name: 'share',
			title: '分享页',
			component: () => import('@/components/share')
		},
    { // 招募
      path: '/unionShare',
      name: 'unionShare',
      title: '邀请',
      component: () => import('@/components/invitePoster/unionShare')
    },
    { // 邀请成功
      path: '/succeed',
      name: 'succeed',
      title: '邀请成功',
      component: () => import('@/components/invitePoster/succeed')
    },
    { // 链接失效
      path: '/shareExpired',
      name: 'shareExpired',
      title: '链接失效',
      component: () => import('@/components/invitePoster/ShareExpired')
    },
    { // 电子签约
      path: '/signature',
      name: 'signature',
      title: '电子签约',
      component: () => import('@/components/Sign/signature')
    },
    { // 签约成功
      path: '/signSucceed',
      name: 'signSucceed',
      title: '电子签约',
      component: () => import('@/components/Sign/signSucceed')
    },
    { // 签约链接失效
      path: '/Expired',
      name: 'Expired',
      title: '链接失效',
      component: () => import('@/components/Sign/Expired')
    },
    { // 预览
      path: '/preview',
      name: 'preview',
      title: '预览',
      component: () => import('@/components/Sign/preview')
    },
		{ // 投资成功提示
			path: '/successMsg',
			name: 'SuccessMsg',
			component: () => import('@/components/common/successMsg')
		},
    { // Invitation
      path: '/invitation',
      name: 'invitation',
      title: '邀请回执',
      component: () => import('@/components/Invitation/index')
    },
    { // Invitation
      path: '/verifyCode',
      name: 'verifyCode',
      title: '验证邀请回执',
      component: () => import('@/components/verifyCode/index')
    },
    { // lose
      path: '/lose',
      name: 'lose',
      title: '页面丢失了',
      component: () => import('@/components/lose')
    },


		{ // 以上路由都匹配不到的时候重定向到首页
			path: '/*',
			redirect: {
				name: 'lose'
			}
		},
	]
});
router.beforeEach(function (to, from, next) {
	window.scrollTo(0, 0);
	if(to.name == 'PeriodDetail' && (from.name == 'projectInfoRecordDetail' || from.name == 'DeveloperReturnList')){
		let periodDate = localStorage.getItem('periodDate');
		to.query.date = periodDate;
	}else if(from.name != 'PeriodDetail' && (to.name != 'projectInfoRecordDetail' || to.name != 'DeveloperReturnList')){
		localStorage.removeItem('periodDate');
	}
	next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js